//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import PrivateChatsFilters from './PrivateChatsFilters.vue';
import Pagination from '~/components/Pagination.vue';
import Table from '~/components/ui/Table.vue';
import User from '~/components/User.vue';
import GetReport from '~/components/GetReport.vue';
import tableConfig from './privateChatsTableConfig';
import utils from '~/utils';
import constant from '~/const';

export default {
  components: {
    PrivateChatsFilters,
    Pagination,
    Table,
    User,
    GetReport,
  },

  data() {
    return {
      selection: [],
      currentChatId: 0,
      loader: false,
      chatLoader: false,
      tableConfig,
      utils,
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),
    ...mapState('privateChats', [
      'privateChats',
      'page',
      'pages',
      'sort',
      'currentChat',
    ]),
    ...mapGetters('privateChats', ['requestData']),
    ...mapGetters('login', ['getAdminById']),

    messagesRequestData() {
      const { currentChatId } = this;
      return {
        conversationId: currentChatId,
      };
    },
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'confirmAction',
    ]),
    ...mapActions('privateChats', {
      getPrivateChatsAction: 'getPrivateChats',
      setPageAction: 'setPage',
      setSortAction: 'setSort',
      deleteChatAction: 'deleteChat',
      loadCurrentChatAction: 'loadCurrentChat',
      deleteChatMessageAction: 'deleteChatMessage',
      editChatMessageAction: 'editChatMessage',
    }),

    async getPrivateChats(data = {}) {
      this.loader = true;
      await this.getPrivateChatsAction(data);
      this.loader = false;
      const { privateChats } = this;
      if (privateChats && privateChats.length) {
        const { id } = privateChats[0];
        this.setCurrentChat({ id });
      }
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
      }

      this.getPrivateChats();
    },

    applySort(data) {
      this.setSortAction(data);
      this.getPrivateChats();
    },

    setPage(value) {
      this.setPageAction(value);
      const extendedRequestData = {
        getTotal: false,
      };
      this.getPrivateChats(extendedRequestData);
    },

    deleteChat(id) {
      const { currentChatId } = this;
      this.confirmAction({
        text: 'Are you sure you want to delete chat?',
        callback: async () => {
          this.loader = true;
          this.setGeneralProgress(true);
          await this.deleteChatAction(id);
          this.chatLoader = true;
          await this.getPrivateChatsAction({});
          await this.loadCurrentChatAction(currentChatId);
          this.chatLoader = false;
          this.loader = false;
          this.setGeneralProgress(false);
          this.setSuccessNotification('Chat deleted');
        },
      });
    },

    setCurrentChat({ id }) {
      this.currentChatId = id;
      this.loadCurrentChat();
    },

    async loadCurrentChat() {
      const { currentChatId } = this;
      this.chatLoader = true;
      this.setGeneralProgress(true);
      await this.loadCurrentChatAction(currentChatId);
      this.chatLoader = false;
      this.setGeneralProgress(false);
    },

    deleteMessage(id) {
      const { currentChatId } = this;
      this.confirmAction({
        text: 'Are you sure you want to delete message?',
        callback: async () => {
          this.setGeneralProgress(true);
          await this.deleteChatMessageAction(id);
          await this.loadCurrentChatAction(currentChatId);
          this.setGeneralProgress(false);
          this.setSuccessNotification('Message deleted');
        },
      });
    },

    editMessage(message) {
      const { currentChatId } = this;
      const { id, text } = message;
      this.confirmAction({
        text: 'Edit message',
        hasPrompt: true,
        promptRequired: true,
        promptLabel: 'Message',
        promptValue: text,
        callback: async ({ prompt }) => {
          this.setGeneralProgress(true);
          await this.editChatMessageAction({
            messageId: id,
            message: prompt,
          });
          await this.loadCurrentChatAction(currentChatId);
          await this.getPrivateChatsAction({});
          this.setGeneralProgress(false);
          this.setSuccessNotification('Message edited');
        },
      });
    },

    isMessageDeletedBy(message) {
      const {
        deletedBySender,
        deletedByReceiver,
        deleted,
        adminId,
      } = message;

      if (deletedBySender) return 'sender';
      if (deletedByReceiver) return 'receiver';
      if (deleted) {
        const admin = this.getAdminById(adminId);
        if (admin) {
          return `${this.$t('admin')}: ${admin.email}`;
        }
        return this.$t('admin');
      }
      return '';
    },

    isMessageEditedBy(message) {
      const { adminId } = message;
      const admin = this.getAdminById(adminId);
      if (admin) {
        return `${this.$t('admin')}: ${admin.email}`;
      }
      return this.$t('admin');
    },

    isMessageDeleted(message) {
      const {
        deletedBySender,
        deletedByReceiver,
        deleted,
      } = message;

      return deletedBySender || deletedByReceiver || deleted;
    },

    isChatDeleted(chat) {
      return chat.deletedByReciver && chat.deletedBySender;
    },

    isChatDeletedBy(chat) {
      const { adminId } = chat;
      const admin = this.getAdminById(adminId);
      if (admin) {
        return `${this.$t('admin')}: ${admin.email}`;
      }
      return this.$t('admin');
    },
  },
};
